import { useState } from "react";
import { motion } from "framer-motion";
import { Maximize2 } from "lucide-react";
import { Dialog, DialogContent } from "./ui/dialog";
import { FLYERS } from "../data/content";

export const Flyers = () => {
  const [selected, setSelected] = useState(null);

  return (
    <section data-testid="flyers-section" className="pb-24 md:pb-32 -mt-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <p className="text-xs uppercase tracking-overline text-[#5B3E96] font-semibold mb-6">
          Anuncios y convocatorias
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {FLYERS.map((f, i) => (
            <motion.button
              key={i}
              type="button"
              onClick={() => setSelected(f)}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              data-testid={`flyer-card-${i}`}
              className="group text-left bg-white border border-[#E8E4EE] rounded-sm overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-[#F4F2F7]">
                <img
                  src={f.src}
                  alt={f.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute inset-0 bg-[#2D1B4E]/0 group-hover:bg-[#2D1B4E]/30 transition-colors flex items-center justify-center">
                  <span className="opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-2 bg-white text-[#2D1B4E] text-xs font-medium px-3 py-2 rounded-sm">
                    <Maximize2 className="w-4 h-4" /> Ampliar
                  </span>
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-serif-display text-base font-semibold text-[#2D1B4E] leading-tight">
                  {f.title}
                </h3>
                {f.caption && (
                  <p className="text-xs text-[#5F5670] mt-1">{f.caption}</p>
                )}
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      <Dialog open={!!selected} onOpenChange={(o) => !o && setSelected(null)}>
        <DialogContent className="max-w-3xl p-2 bg-transparent border-0 shadow-none" data-testid="flyer-modal">
          {selected && (
            <img
              src={selected.src}
              alt={selected.title}
              className="w-full h-auto max-h-[85vh] object-contain rounded-sm"
            />
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
